var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-22ab0297\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./strips.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppSvgIcon/iconsTemplate/contents/strips.vue
// module id = 614826ebb8e1578d1182
// module chunks = 89